/* eslint-disable no-new */
require('./styles/style.css')
require('focus-visible')
import './polyfill'
import './filters'
import './directives'
import './registerServiceWorker'
import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
import VueAnalytics from 'vue-analytics'
import VTooltip from 'v-tooltip'
import router from './router'
import store from './store/index'
import {sync} from 'vuex-router-sync'
import App from './App'
import api from './lib/api'
import auth from '@/lib/auth'
import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'
import vClickOutside from 'v-click-outside'

Vue.use(VueAnalytics, {
  id: 'UA-110342102-2',
  router,
  debug: {
    // enabled: process.env.NODE_ENV !== 'production',
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://5a41a17589e1475f93091249d955b6c4@sentry.io/231459',
    release: process.env.VUE_APP_VERSION,
    environment: process.env.VUE_APP_ENV,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['https://landscapeapi.com', /^\//]
      })
    ],
    tracesSampleRate: 0.5
  })
}

Vue.config.productionTip = false
Vue.use(VTooltip)
Vue.use(AsyncComputed)
Vue.use(vClickOutside)
sync(store, router)

async function init() {
  api.init()
  await auth.init()
  store.dispatch('init')
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
}

init().catch(e => auth.logout(e.errorDescription || e))
